import { siteConfig } from '@seek/melways-sites';

import type { ConfigContextTypes } from 'src/shared/types';

const getBrand = (site: ConfigContextTypes['site']) => {
  const product = siteConfig[site].classification.product;

  if (product === 'candidate') {
    return siteConfig[site].classification.brand;
  }

  switch (siteConfig[site].classification.country) {
    case 'hk':
    case 'th':
      return 'jobsdb';
    case 'id':
    case 'my':
    case 'ph':
    case 'sg':
      return 'jobstreet';
    default:
      return 'seek';
  }
};

export default getBrand;
